
export const GROUP_END_TITLE_KEYS = new Set<string>([
  // 'AttributeTimesheetEvent',                       // Typ dnia
  'ActualScheduledWorkTimeTimesheetEvent',         // Plan pracy
  'WorkTimeTimesheetEvent',                        // Suma pracy
  'AdditionalTimeToWorkTimeChildEvent',            // Przestój
  'ForeignCountryCalculatedWorkTimeTimesheetEvent',// Praca w kraju
  'WorkTimesheetChildEvent',                       // Inne prace
  // 'Duty50TimesheetEvent',                          // Dyżur 50%
  'HolildayWorkTimeTimesheetEvent',                // Praca w niedz. i św.
])


